/**
 * Constants for T&M Log features
 */

// Report Type Options (hardcoded for now, will be API-driven later)
export const REPORT_TYPE_OPTIONS = [
  { value: "RS_DFA", label: "R&S T&M Tag" },
  { value: "City_DWR", label: "Disputed Work Form" },
  { value: "City_DFA", label: "Daily Force Account Report" },
];

/**
 * Generate T&M ID string from job number and report id
 * Format: TM-{jobNumber}-{reportId}
 */
export const generateTMId = (jobNumber, reportId) => {
  if (!jobNumber || !reportId) return "N/A";
  return `TM-${jobNumber}-${String(reportId).padStart(3, "0")}`;
};
